module.exports = __webpack_public_path__ + "img/89d202a.svg";